import { Directive, Input } from '@angular/core';

@Directive()
export abstract class PictureBaseComponent {
  @Input() src = '';
  @Input() className?: string;
  @Input() height?: number;
  @Input() width?: number;
}
